import React from 'react';
import ReactDOM from 'react-dom/client';
import App from 'components/main/App';
import reportWebVitals from 'reportWebVitals';
// import 'antd/dist/reset.css';
import * as _ from 'global';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
// reportWebVitals();
